module.exports = __webpack_public_path__ + "img/banner1.1c278702.png";